import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './assets/i18n/en.json';
import ar from './assets/i18n/ar.json';
import hi from './assets/i18n/hi.json';
import ml from './assets/i18n/ml.json';
import cn from './assets/i18n/cn.json';
import du from './assets/i18n/du.json';
import es from './assets/i18n/es.json';
import fr from './assets/i18n/fr.json';
import pt from './assets/i18n/pt.json';

// One-time migration: 'ae' was a non-standard code, replaced by ISO 639-1 'ar'
try {
    if (localStorage.getItem('i18nextLng') === 'ae') {
        localStorage.setItem('i18nextLng', 'ar');
    }
} catch (e) {
    /* storage unavailable (private mode) — detector falls back to navigator */
}

// Keep <html lang/dir> in sync with the active language. The first paint is
// handled by the inline script in public/index.html; this covers init + runtime
// switches. Registered BEFORE init — languageChanged fires during init itself.
//
// layout_type must be written too: the ThemeCustomizer (LayoutType.jsx) re-asserts
// document.documentElement.dir from localStorage.layout_type on mount and would
// otherwise stomp the language-driven dir back to ltr after a reload.
const syncHtmlLang = (lng) => {
    const dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
    document.documentElement.dir = dir;
    try {
        localStorage.setItem('layout_type', dir);
    } catch (e) { /* private mode */ }
    if (document.body) {
        document.body.classList.toggle('rtl', dir === 'rtl');
        document.body.classList.toggle('ltr', dir === 'ltr');
    }
};
i18n.on('languageChanged', syncHtmlLang);

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translations: en },
            ar: { translations: ar },
            hi: { translations: hi },
            ml: { translations: ml },
            cn: { translations: cn },
            du: { translations: du },
            es: { translations: es },
            fr: { translations: fr },
            pt: { translations: pt }
        },
        fallbackLng: 'en',
        debug: false,

        // have a common namespace used around the full app
        ns: ['translations'],
        defaultNS: 'translations',

        keySeparator: false, // we use content as keys

        interpolation: {
            escapeValue: false
        },

        detection: {
            caches: ['localStorage']
        }
    })
    .then(() => syncHtmlLang(i18n.language || 'en'));

export default i18n;
